import React from 'react';
import type { FC } from 'react';
import type { SelectOption } from '@wix/cli-ui-kit';
import { Link, SelectInput, SelectOptionAvailability } from '@wix/cli-ui-kit';
import { Trans, useTranslation } from '@wix/cli-i18n';
import { useWixCliAppBi } from '../../../bi/index.js';
import { ReleaseVersionType } from '../types.js';

interface ChooseVersionProps {
  nextMinor?: string;
  nextMajor: string;
  onChosen: (props: ReleaseVersionType) => void;
}

export const ChooseVersion: FC<ChooseVersionProps> = (props) => {
  const { nextMinor, nextMajor, onChosen } = props;

  const bi = useWixCliAppBi();
  const { t } = useTranslation();

  const options: Array<SelectOption<ReleaseVersionType>> = [
    {
      title: nextMinor
        ? t('release_command.version.minor', {
            version: nextMinor,
          })
        : t('release_command.version.minor_disabled'),
      description: t('release_command.version.minor.description'),
      value: ReleaseVersionType.MINOR,
      availability: nextMinor
        ? SelectOptionAvailability.Enabled()
        : SelectOptionAvailability.Disabled({
            reason: (
              <Trans
                i18nKey="release_command.version.minor.disabled"
                components={[
                  // https://dev.wix.com/docs/build-apps/manage-your-app/versioning/about-app-versioning
                  <Link url="https://wix.to/ZR80Y7p" />,
                ]}
              />
            ),
          }),
    },
    {
      title: t('release_command.version.major', {
        version: nextMajor,
      }),
      description: t('release_command.version.major.description'),
      value: ReleaseVersionType.MAJOR,
    },
  ];

  return (
    <SelectInput<ReleaseVersionType>
      label={t('release_command.version_type_question')}
      options={options}
      initialIndex={nextMinor ? 0 : 1}
      onSubmit={({ value }) => {
        bi.cliFlowStepAnswered({
          question: t('release_command.version_type_question'),
          questionKey: 'release_command.version_type_question',
          answer: value,
        });
        onChosen(value);
      }}
    />
  );
};
